module.exports = __webpack_public_path__ + "static/media/chevron-right.659b918a.svg";